module.exports = __webpack_public_path__ + "img/title3.02fa1ac3.png";